// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__fzPg1","content":"TermsOfServicePage_content__3MqP9"};